import Vue from 'vue'
import store from 'store'

// 链接添加语言参数
Vue.filter('langParam', url => {
  if (!url) return ''
  if (url.indexOf('?') >= 0) {
    url = url + '&'
  } else {
    url = url + '?'
  }
  return url + 'lang=' + store.getters.languageServerNeed
})
